import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class StockAPI {

    URI_V1 = "/v1/stocks"
    URI_V2 = "/v1/stocks"

    createProduct = async (data: any) => {
        return await apiService.post(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

    createMovement = async (data: any) => {
        return await apiService.post(`${this.URI_V2}?companyId=${companyAPI.getCompanyManagment().id}`, data);
    }

    getProducts = async () => {
        return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getSummary = async () => {
        return await apiService.get(`${this.URI_V1}/summary-value?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    deleteProduct = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };

    updateProduct = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    movementStock = async (data: any) => {
        return await apiService.put(`${this.URI_V1}/movement`, data);
    };

    historyProduct = async (id: any) => {
        return await apiService.get(`${this.URI_V1}/${id}/history`);
    };

    deleteMovement = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}/movement?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getCommission = async (filter: any) => {
        return await apiService.get(`${this.URI_V1}/commission?companyId=${companyAPI.getCompanyManagment().id}&startDate=${filter.startDate}&endDate=${filter.endDate}`);
    };


    getCommissionEmployee = async (filter: any) => {
        return await apiService.get(`${this.URI_V1}/commission-me?companyId=${companyAPI.getCompanyManagment().id}&startDate=${filter.startDate}&endDate=${filter.endDate}`);
    };


    getCommissionDetails = async (employeeId: any) => {
        return await apiService.get(`${this.URI_V1}/commission/details?companyId=${companyAPI.getCompanyManagment().id}&employeeId=${employeeId}`);
    };

    confirmPayment = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/payment-commission?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

    getCancelCommission = async (employeeId: any, historyId: any) => {
        return await apiService.delete(`${this.URI_V1}/commission?companyId=${companyAPI.getCompanyManagment().id}&employeeId=${employeeId}&historyId=${historyId}`);
    };

    confirmPaymentByHistory = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/payment-commission-history?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };
}
